module.exports = __webpack_public_path__ + "static/media/logo_tkg.b536f6c3.png";